import * as React from "react";
import CartItem from "./CartItem.jsx";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "../../../redux/action/cart.js";
import { toast } from "react-toastify";
import { MdDelete } from "react-icons/md";
import { FaPoundSign, FaMinus, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function CartItems() {
  const { cart } = useSelector((state) => state.cart);
  const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
  console.log(cart);
  
  
  const [buttonSize, setButtonSize] = React.useState({
    fontSize: "8px",
    width: "20px",
    height: "20px",
  });

  const dispatch = useDispatch();
  React.useEffect(() => {
    if (cart?.length === 0 && existingCart?.length > 0) {
      existingCart.forEach((item) => dispatch(addToCart(item)));
    }
  }, [cart, existingCart, dispatch]);
  // Dynamically update button size based on screen size
  React.useEffect(() => {
    const updateButtonSize = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1024) {
        setButtonSize({ fontSize: "24px", width: "54px", height: "54px" });
      } else if (screenWidth >= 768) {
        setButtonSize({ fontSize: "16px", width: "38px", height: "38px" });
      } else {
        setButtonSize({ fontSize: "12px", width: "20px", height: "20px" });
      }
    };

    updateButtonSize();
    window.addEventListener("resize", updateButtonSize);

    return () => {
      window.removeEventListener("resize", updateButtonSize);
    };
  }, []);

  const removeFromCartHandler = (item) => {
    dispatch(removeFromCart(item));
    localStorage.setItem('cart', JSON.stringify([]));
  };

  const increment = (item) => {
    if (item.stock <= item.quantity) {
      toast.error("Product stock limited!");
      return;
    }

    const updatedCartData = { ...item, quantity: item.quantity + 1 };
    dispatch(addToCart(updatedCartData));
  };

  const decrement = (item) => {
    if (item.quantity === 1) {
      removeFromCartHandler(item)
      localStorage.setItem('cart', JSON.stringify([]));
    }else{

      const updatedCartData = { ...item, quantity: item.quantity - 1 };
      dispatch(addToCart(updatedCartData));
    }

  };

  const truncateDescription = (desc) => {
    const words = desc?.split(" ");
    if (words?.length > 4) {
      return words?.slice(0, 4).join(" ") + "...";
    }
    return desc;
  };

  return (
    <section className="flex flex-wrap justify-between self-center md:px-8 px-2 pt-5 pb-9 mt-11 font-semibold bg-white rounded-xl border-2 border-solid border-black border-opacity-10 md:w-[90%] w-[95%] max-md:px-5 max-md:mt-10">
      <h1 className="heading leading-4 text-amber-600 mt-3 md:text-[2rem]">Items</h1>
      {cart.map((item) => (
        <div
          key={item.productId} // Ensure a unique key
          className="flex flex-nowrap md:gap-5 justify-between items-center mt-9 w-full"
        >
          <div className="flex md:flex-row flex-col gap-5 items-center rounded-md md:min-w-[240px] w-[350px] md:w-[393px]">
            <img
              loading="lazy"
              src={item?.images?.[0] || item?.image}
              alt={item.name}
              className="object-cover shrink-0 w-[120px] h-[100px] rounded-md"
            />
            <div className="flex flex-col items-start my-auto">
              <div className="lg:text-[24px] flex justify-center items-center text-[12.01px] md:text-[16.78px] sm:text-[12.01px] leading-none text-[#C97C2A] font-baloo font-semibold">
                <p className="md:text-lg text-[14px] text-[#C97C2A] flex items-center">
                  <div className="flex items-center justify-center">
                    <FaPoundSign className="" /> {item.basePrice}
                  </div>
                </p>
                
                {item.actualPrice && (
                  <div className="font-[700] flex text-[16px] text-[#d55b45] pl-3 mt-[-4px] line-through">
                    £{item.actualPrice}
                  </div>
                )}
              </div>
             
              <div className=" self-stretch text-base lg:text-[16px] md:text-[11.19px] text-[6.81px] sm:text-[6.01px] leading-none text-[#000000]">
                {item.name}
              </div>
              <div className="mt-2.5 font-semibold font-baloo sm:text-[7.01px] text-[7.01px] lg:text-[18px] md:text-[12.59px] text-[#03081F]">
                {truncateDescription(item.description)}
              </div>
            </div>
          </div>
          <div className="flex md:gap-5 gap-1 items-center text-xl text-center whitespace-nowrap rounded-none text-neutral-700 w-[160px] md:w-[222px]">
            <div
              style={{
                width: buttonSize.width,
                height: buttonSize.height,
                backgroundColor: "#D2D1CD",
                borderRadius: "8px",
              }}
              className="flex items-center justify-center"
            >
              <button aria-label="Decrease quantity" onClick={() => decrement(item)}>
                <FaMinus style={{ fontSize: buttonSize.fontSize, color: "white" }} />
              </button>
            </div>
            <div className="my-auto tex-[6.07px] sm:text-[12.07px] lg:text-[20px] md:text-[13.99px] font-baloo font-semibold">
              {item.quantity}
            </div>
            <div
              style={{
                width: buttonSize.width,
                height: buttonSize.height,
                backgroundColor: "#AF313D",
                borderRadius: "8px",
              }}
              className="flex items-center justify-center"
            >
              <button aria-label="Increase quantity" onClick={() => increment(item)}>
                <FaPlus style={{ fontSize: buttonSize.fontSize, color: "white" }} />
              </button>
            </div>
          </div>
          <div className="flex items-center bg-[#C97C2A] md:w-[53.11px] min-w-[19.17px] min-h-[18.54px] md:h-[45.47px] rounded-md justify-center">
            <button aria-label="Remove item">
              <MdDelete
                onClick={() => removeFromCartHandler(item)}
                color="white"
                className="md:text-[1.5rem] text-[.8rem]"
              />
            </button>
          </div>
        </div>
      ))}
      <Link to="/menu">
        <button className="mt-9 lg:text-[26px] text-[7.9px] sm:text-[7.9px] font-bold font-baloo leading-none text-center text-white bg-[#AF313D] lg:w-[252px] lg:h-[75px] h-[22.78px] md:w-[176.21px] md:h-[52.44px] sm:h-[22.78px] sm:w-[76.53px] w-[76.53px] md:text-[18.18px] rounded-md">
          Add New Item
        </button>
      </Link>
    </section>
  );
}
